import React, {Component} from 'react';
import {AJAX} from "../functions";
import $ from 'jquery';
//window.$ = window.jQuery = $;
import 'slick-carousel';
import Swipe from 'react-easy-swipe';

class OurFleetPage extends Component {
    constructor(props) {
        super(props);
        this.onSwipeStart = this.onSwipeStart.bind(this);
        this.onSwipeMove = this.onSwipeMove.bind(this);
        this.onSwipeEnd = this.onSwipeEnd.bind(this);

        this.state = {
            container: "#carousel",
            sinus:   [0],
            images:  null,
            mIndex:  null,
            sinsum: 0,
            shadow: true,
            squeeze: 50,
            animate: 250,
            content: '',
            data: '',
            x: 0
        };
    }
    componentDidMount() {
        this.getPages();
    }
    componentWillUnmount() {
        this.destroySliders();
    }
    destroySliders() {
        if ($('.vehicle-slider-mobile-nav').hasClass('slick-initialized')) {
            $('.vehicle-slider-mobile-nav').slick('unslick');
        }
        if ($('.vehicle-slider-mobile').hasClass('slick-initialized')) {
            $('.vehicle-slider-mobile').slick('unslick');
        }
        $('[class^="vehicle-slider-"]').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        });
        $('[class^="vehicle-slider-nav-"]').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        });
    }

    componentWillUnmount() {
        this.destroySliders();
    }

    destroySliders() {
        if ($('.vehicle-slider-mobile-nav').hasClass('slick-initialized')) {
            $('.vehicle-slider-mobile-nav').slick('unslick');
        }
        if ($('.vehicle-slider-mobile').hasClass('slick-initialized')) {
            $('.vehicle-slider-mobile').slick('unslick');
        }
        $('[class^="vehicle-slider-"]').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        });
        $('[class^="vehicle-slider-nav-"]').each(function () {
            if ($(this).hasClass('slick-initialized')) {
                $(this).slick('unslick');
            }
        });
    }

    slidingCarousel() {
        this.setupCarousel();
    }

    preload(callback) {
        let images = $(this.state.container).find('.slide .flip-box-front img.carousel-image'),
            total  = images.length,
            shift  = total % 2,
            middle = total < 3 ? total : ~~(total / 2) + shift,
            result = [],
            loaded = 0;

        let t = this;
        images.each(function (index, element) {
            let img = new Image();

            $(img).bind('load error', function () {
                loaded++;

                // push loaded images into regular array.
                // to preserve the order array gets constructed so, that elements indexed:
                //
                //    0 1 2 3 4 5 6
                //
                // are shifted within destination array by half of total length (-1 depending on parity/oddness):
                //
                //    6 5 4 0 1 2 3
                //
                // and finally reversed to get correct scrolling direction.

                result[(index+middle-shift) % total] = element;

                // need ratio for calculating new widths
//                element.ratio = this.width / this.height;
                element.ratio = 150 / 230;
//                element.origH = this.height;
                element.origH = 230;
                element.idx   = index;

                if (loaded == total) {
                    let mIndex = middle;
                    let sinsum = 0;
                    let images = result.reverse();
                    let sinus = t.state.sinus;

                    // prepare symetric sinus table

                    for (let n=1, freq=0; n<total; n++) {
                        sinus[n] = (n<=middle) ? Math.sin(freq+=(2/middle)) : sinus[total-n];

                        if (n < middle)
                            sinsum += sinus[n]*t.state.squeeze;
                    }
                    t.setState({mIndex: mIndex, sinsum: sinsum, images: images, sinus: sinus});

                    callback(images, t, 'none'); // for first time no rotate
                }
            });
            img.src = element.src;
        });
    }

    setupEvents() {
        let t = this;
        $(t.state.container)
            .find('.slide .flip-box-front > img.carousel-image').click(function() {
            let idx = $(this)[0].idx,
                arr = t.state.images,
                el = $(this).closest('.slide');

            while (arr[t.state.mIndex-1].idx != idx ) {
                arr.push(arr.shift());
            }
            t.doLayout(arr, t, el.attr("data-direction"), true);
        })
            .end()
            .find('.navigate-right').click(function() {
            let images = t.state.images;

            images.splice(0,0,images.pop());
            t.doLayout(images, t, 'left', true);
        })
            .end()
            .find('.navigate-left').click(function() {
            let images = t.state.images;

            images.push(images.shift());
            t.doLayout(images, t, 'right', true);
        });
    }

    doLayout(images, t, direction, animate) {
        let mid  = t.state.mIndex,
            sin  = t.state.sinus,
            posx = 0,
            diff = 0,
            width  = images[mid-1].origH * images[mid-1].ratio,  // width of middle picture
            middle = ((window.screen.availWidth - 20) - width)/2,   // center of middle picture, relative to container
            offset = middle - t.state.sinsum,                 // to get the center, all sinus offset that will be added below have to be substracted
            height = images[mid-1].origH, top, left, idx, j=1;


        // hide description before doing layout
//        $(t.state.container).find('div.hide').hide().css('opacity', 0);

        $.each(images, function(i, img) {
            idx = Math.abs(i+1-mid);
            top = idx * 15;

            // calculating new width and caching it for later use
            img.cWidth = (height-(top*2)) * img.ratio;

            diff = sin[i] * t.state.squeeze;
            left = posx += (i < mid) ? diff : images[i-1].cWidth + diff - img.cWidth;

            let el = $(img).closest('.slide');

            if (i === mid-1) { // main image
                if (direction !== 'none')
                    $(img).closest('.flip-box-inner').css('transition', 'transform 1.2s');
                else
                    $(img).closest('.flip-box-inner').css('transition', 'none');  // for first time no rotate

                if (direction === 'left') {
                    $(img).closest('.flip-box-inner').css('transform', 'rotateY(180deg)');
                    el.find('.flip-box-back').css('transform', 'rotateY(180deg)');
                }
                else {
                    $(img).closest('.flip-box-inner').css('transform', 'rotateY(-180deg)');
                    el.find('.flip-box-back').css('transform', 'rotateY(180deg)');
                }
            }
            else {
                $(img).closest('.flip-box-inner').css('transition', 'none');
                $(img).closest('.flip-box-inner').css('transform', 'none');

                if (i < mid) // set direction
                    el.attr("data-direction", 'left');
                else
                    el.attr("data-direction", 'right');
            }

            let fn = function() {
                if (i === mid-1) {
                    // show caption gently
                    $('#our-fleet-content div[data-id="'+(el.attr("data-id"))+'"]').show();

                    if (!$('.vehicles-slider-'+el.attr("data-id")).hasClass('slick-initialized'))
                        $('.vehicles-slider-'+el.attr("data-id")).slick({
                            dots: false,
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            fade: true,
                            speed: 800,
                            pauseOnHover: false,
                            autoplay: true,
                            autoplaySpeed: 5000,
                            asNavFor: '.vehicles-slider-nav-'+el.attr("data-id"),
                            adaptiveHeight: true
                        });

                    if (!$('.vehicles-slider-nav-'+el.attr("data-id")).hasClass('slick-initialized'))
                        $('.vehicles-slider-nav-'+el.attr("data-id")).slick({
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            asNavFor: '.vehicles-slider-'+el.attr("data-id"),
                            dots: false,
                            arrows: true,
                            centerMode: true,
                            focusOnSelect: true,
                            centerPadding: '0',
                        });
                }
                else {
                    $('#our-fleet-content div[data-id="' + (el.attr("data-id")) + '"]').hide();

                    if ($('.vehicles-slider-'+el.attr("data-id")).hasClass('slick-initialized'))
                        $('.vehicles-slider-'+el.attr("data-id")).slick('unslick');

                    if ($('.vehicles-slider-nav-'+el.attr("data-id")).hasClass('slick-initialized'))
                        $('.vehicles-slider-nav-'+el.attr("data-id")).slick('unslick');
                }
            };

            if (animate) {
                if ((mid-idx) > 0) {
                    el.show();
                }
                else {
                    el.hide();
                }

                if (i == mid - 1) { // for main unset animation
                    el.css({
                        zIndex: mid - idx,
                        height: height - (top * 2),
                        width: (height - (top * 2)) * img.ratio,
                        top: top,
                        left: left + offset,
                        opacity: 0
                    }).animate({opacity: i == mid - 1 ? 1 : sin[j++] * 0.8}, fn);
                }
                else {
                    el.animate({
                        zIndex: mid - idx,
                        height: height - (top * 2),
                        width: (height-(top*2)) * img.ratio,
                        top: top,
                        left: left + offset,
                        opacity: i == mid - 1 ? 1 : sin[j++] * 0.8
                    }, t.state.animate, fn);
                }
            }
            else
            {
                if ((mid-idx) > 0) {
                    el.show();

                    if (t.state.shadow) {
                        el.addClass('shadow');
                    }
                }
                else {
                    el.hide();
                }
                el.css({
                    zIndex: mid - idx,
                    height: height - (top * 2),
                    width: (height-(top*2)) * img.ratio,
                    top: top,
                    left: left + offset,
                    opacity: 0
                }).animate({opacity: i == mid - 1 ? 1 : sin[j++] * 0.8}, fn);
            }
        });

        if (!animate) {
            $(t.state.container)
                .find('.navigate-left').css('left', middle+width-75)
                .end()
                .find('.navigate-right').css('left', middle-30);
        }
    }

    setupCarousel() {
        this.preload(this.doLayout);
        this.setupEvents();
    }

    loadLazy() {
        $('.lazy').each(function () {
            let el =$(this);
            let src = el.data('lazy-src');
            el.attr('src', src);
        })
    }

    getPages() {
        let params = {action: 'api/booking/our_fleet_new'};
        let t = this;
        AJAX(bm_ajax_url, 'POST', params, {
            response_json: true,
            func_callback: function (resp) {
                t.setState({content: resp.content, data: resp.data})
                t.slidingCarousel();
                t.loadLazy();

//                lightbox.enable();
//                lightbox.build();
            },
            func_error: function (resp) {
                console.log('error: ' + resp.message);
            }
        });
    }

    onSwipeStart() {
        this.setState({x: 0});
    }

    onSwipeEnd(event, images) {
        if (this.state.x > 50) {
            images.splice(0,0,images.pop());
            this.doLayout(images, this, 'left', true);
        }
        else if (this.state.x < -50) {
            images.push(images.shift());
            this.doLayout(images, this, 'right', true);
        }
        this.setState({x: 0});
    }

    onSwipeMove(position) {
        this.setState({x: position.x});
    }

    render() {

        return (
            <div className={'value-space our-fleet-page'}>
                <div className="row" style={{margin: "0px"}}>
                    <div className="col-10" style={{flex: "0 0 auto", maxWidth: "none", marginLeft: "5px", padding: "0px"}}>
                        <Swipe
                            onSwipeStart={this.onSwipeStart}
                            onSwipeEnd={(event) =>{this.onSwipeEnd(event, this.state.images)}}
                            onSwipeMove={(position) =>{this.onSwipeMove(position)}}>

                            <div id="carousel" dangerouslySetInnerHTML={{__html: this.state.content}}>
                            </div>
                        </Swipe>
                    </div>
                </div>
                <div id={'our-fleet-content'} className="text-center" dangerouslySetInnerHTML={{__html: this.state.data}}>

                </div>
            </div>
        );
    }
}

export default OurFleetPage;